import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteClothIssue } from '../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import axios from 'axios';

const TableBody2 = ({
    serialNumber,
    id,
    nId,
    dt,
    numMemo,
    numInwMemo,
    sono,
    orderno,
    empNm,
    sts,
    reqty,
    issqty,
    firmId,
    firmNm,
    userId,
    userNm,
    selected,
    handleClick,
}) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        // Show confirmation dialog|
        const isConfirmed = window.confirm("Are you sure you want to delete this Numbering Return?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteNumbering(id)
        }

    };

    const handleViewClick = () => {
        window.open(`/NumberingInwView/${nId}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNumberingReturn = () => {
        window.open(`/NumberingIssueReturn/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    const deleteNumbering = async (id) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deleteNumberingReturnReg&ninwId=${id}`);
            // console.log(res);
            const msg = res?.data;
            alert(msg.msg);
        } catch (error) {
            console.error("Error deleting Item:", error);
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {numInwMemo}
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {numMemo}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {orderno}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm || '-'}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {issqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {reqty}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell>
                {/* 
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <Button  variant="contained" color="primary" onClick={handleNumberingReturn}>Return</Button>
                </TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>

                {userdata?.role === "1" &&
                    <TableCell sx={{ p: 0.4, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                        {userNm}
                    </TableCell>}
            </TableRow>
        </>
    );
};

export default React.memo(TableBody2);